import React from 'react';
import FilterDatePicker from '../FilterDatePicker';

export default function DatePicker(props) {
  return <FilterDatePicker {...props} />;
}